import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';
import { frontendURL } from 'dashboard/helper/URLHelper';

const meta = { permissions: [...ROLES, ...CONVERSATION_PERMISSIONS] };
const component = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/smart-reminders'),
    name: 'smart_reminders_index',
    meta,
    redirect: { name: 'smart_reminders_rules' },
  },
  {
    path: frontendURL('accounts/:accountId/smart-reminders/rules'),
    name: 'smart_reminders_rules',
    meta,
    component,
  },
  {
    path: frontendURL('accounts/:accountId/smart-reminders/messages'),
    name: 'smart_reminders_messages',
    meta,
    component,
  },
];
